<template>
  <div class="AddLeiBieModal">
    <el-dialog
        :title="title"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @open="handleOpen"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="场景名称" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <div v-if="permissionCode.has('research:product:price')">
          <el-form-item label="企业可购:">
            <el-checkbox v-model="form.commercial">
            </el-checkbox>
          </el-form-item>
          <el-form-item label="企业价:">
            <el-input-number
                v-model="form.buyOutPrice"
                :precision="2"
                :step="1"
                :min="0"
            ></el-input-number>
            元
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "AddLeiBieModal",
  data() {
    return {
      form: {
        id: null,
        name: "",
        buyOutPrice: null,
        commercial: null
      },
      title: "",
      rules: {
        name: [
          {
            required: true,
            message: "请输入部门场景名称",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[\s\S]{0,8}$/,
            message: "不得超过8个文字",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("fuzhu", ["leiBieList", "rowDetails"]),
    ...mapState("user", ["permissionCode"]),
    visible: {
      get() {
        return this.$store.state.fuzhu.addTagAttributeVisible;
      },
      set(value) {
        this.$store.commit("fuzhu/setData", {
          key: "addTagAttributeVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapActions("fuzhu", ["saveLeiBie", "getLeiBieList"]),
    ...mapMutations("fuzhu", ["setData"]),
    // 确定添加
    async handleConfirm() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveLeiBie({
            ...this.form,
            buyOutPrice: this.sendPrice(this.form.buyOutPrice)
          });
          await this.getLeiBieList({
            page: this.leiBieList.page,
            size: this.leiBieList.size,
          });
          if (this.form.id) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("添加成功");
          }
          this.setData({
            key: "addTagAttributeVisible",
            value: false,
          });
        }
      });
    },
    clearForm() {
      Object.keys(this.form).map((key) => {
        this.form[key] = null;
      });
    },
    handleOpen() {
      this.clearForm();
      Object.keys(this.form).map((key) => {
        this.form[key] = this.rowDetails[key];
      });
      this.form.buyOutPrice = this.price(this.form.buyOutPrice);
      if (this.form.id) {
        this.title = "编辑部门场景";
      } else {
        this.title = "新增部门场景";
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    price(val) {
      if (!val) {
        return null;
      } else {
        return val / 100;
      }
    },
    sendPrice(val) {
      if (!val) {
        return null;
      } else {
        return val * 100;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.AddLeiBieModal {
}
</style>
